export default __webpack_public_path__ + "static/media/user-auth.9f6b0dde.png";